var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.33 0 41.71 60.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51868 34.4189C7.07159 27.1903 9.46307 20.3629 12.658 13.9028C15.6652 16.5026 18.5165 19.2278 21.1876 22.1694C17.7116 25.9969 14.5717 30.078 11.7295 34.4189H5.51868Z",
    fill: "#FF6842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8941 34.419C35.3449 27.1638 32.9045 20.3865 29.7172 13.9028C26.7172 16.5121 23.8147 19.1721 21.15 22.1245C24.6176 25.966 27.75 30.0621 30.5855 34.419H36.8941Z",
    fill: "#FF6842"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.658 13.903C9.50169 20.3283 7.07212 27.2448 5.51871 34.4191C2.3174 30.7905 0.333313 26.0434 0.333313 20.8478C0.333313 15.9752 2.03912 11.497 4.89178 7.96606C7.58306 9.84424 10.1748 11.7735 12.658 13.903Z",
    fill: "#FFA957"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7172 13.903C32.8735 20.3283 35.3031 27.2448 36.8565 34.4191C40.0578 30.7905 42.0419 26.0434 42.0419 20.8478C42.0419 15.9752 40.3361 11.497 37.4834 7.96606C34.7921 9.84424 32.2004 11.7735 29.7172 13.903Z",
    fill: "#FFA957"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6059 34.419C14.4738 30.0856 17.6801 25.9902 21.1875 22.1694C24.6951 25.9902 27.9014 30.0854 30.7693 34.4187L11.6059 34.419Z",
    fill: "#BF154B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1875 0C24.4348 4.34616 27.295 8.99839 29.7173 13.9055C26.7086 16.5112 23.8599 19.2212 21.1875 22.1694C18.5154 19.2212 15.6664 16.5112 12.658 13.9055C15.08 8.99839 17.9404 4.34616 21.1875 0Z",
    fill: "#FFD00A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6717 38.5522L21.5807 60.5289C21.41 60.7837 21.035 60.7837 20.8646 60.5289L7.77325 38.5522H34.6717Z",
    fill: "#606366"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLogo);
export default __webpack_public_path__ + "static/media/locker_logo.aaebcad4ab9b2aa5ba86b1c6d0062ce3.svg";
export { ForwardRef as ReactComponent };